<template>
  <div class="calculator-page">
    <div class="page-header">
      <h1>Калькулятор</h1>
      <div class="header-actions" v-if="canEditCalculator">
        <button 
          class="btn btn-primary"
          @click="toggleEditMode"
        >
          <i class="bx bx-edit-alt"></i>
          {{ isEditMode ? 'Обычный режим' : 'Режим редактирования' }}
        </button>
      </div>
    </div>
    
    <!-- Переключатель калькуляторов -->
    <div class="calculator-tabs" v-if="!isEditMode">
      <div class="tabs-container">
        <button 
          v-for="calculator in calculators"
          :key="calculator.id"
          :class="['tab-button', { active: currentCalculator === calculator.id }]"
          @click="switchCalculator(calculator.id)"
        >
          <i :class="calculator.icon"></i>
          {{ calculator.name }}
        </button>
      </div>
    </div>
    
    <div class="page-content">
      <div class="calculator-container">
        <!-- Редакторы калькуляторов -->
        <AviationCalculatorEdit 
          v-if="isEditMode && currentCalculator === 'aviation'"
          @close-editor="toggleEditMode"
        />
        <RailwayCalculatorEdit 
          v-else-if="isEditMode && currentCalculator === 'railway'"
          @close-editor="toggleEditMode"
        />
        <AutoCalculatorEdit 
          v-else-if="isEditMode && currentCalculator === 'auto'"
          @close-editor="toggleEditMode"
        />
        <SeaCalculatorEdit 
          v-else-if="isEditMode && currentCalculator === 'sea'"
          @close-editor="toggleEditMode"
        />
        
        <!-- Обычные калькуляторы -->
        <AviationCalculator v-else-if="currentCalculator === 'aviation'" />
        <RailwayCalculator v-else-if="currentCalculator === 'railway'" />
        <AutoCalculator v-else-if="currentCalculator === 'auto'" />
        <SeaCalculator v-else-if="currentCalculator === 'sea'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AviationCalculator from '@/components/calculator/AviationCalculator.vue'
import RailwayCalculator from '@/components/calculator/RailwayCalculator.vue'
import AutoCalculator from '@/components/calculator/AutoCalculator.vue'
import SeaCalculator from '@/components/calculator/SeaCalculator.vue'
import AviationCalculatorEdit from '@/components/calculator/AviationCalculatorEdit.vue'
import RailwayCalculatorEdit from '@/components/calculator/RailwayCalculatorEdit.vue'
import AutoCalculatorEdit from '@/components/calculator/AutoCalculatorEdit.vue'
import SeaCalculatorEdit from '@/components/calculator/SeaCalculatorEdit.vue'

export default {
  name: 'Calculator',
  
  components: {
    AviationCalculator,
    RailwayCalculator,
    AutoCalculator,
    SeaCalculator,
    AviationCalculatorEdit,
    RailwayCalculatorEdit,
    AutoCalculatorEdit,
    SeaCalculatorEdit
  },
  
  data() {
    return {
      isEditMode: false,
      currentCalculator: 'aviation', // По умолчанию Авиа
      calculators: [
        {
          id: 'aviation',
          name: 'Авиа перевозки',
          icon: 'bx bxs-plane-take-off'
        },
        {
          id: 'railway',
          name: 'ЖД перевозки',
          icon: 'bx bx-train'
        },
        {
          id: 'auto',
          name: 'Авто перевозки',
          icon: 'bx bxs-truck'
        },
        {
          id: 'sea',
          name: 'Морские перевозки',
          icon: 'bx bxs-ship'
        }
      ]
    }
  },
  
  computed: {
    ...mapGetters('auth', ['currentUser']),
    
    canEditCalculator() {
      const userRoles = this.currentUser.role || []
      const allowedRoles = [
        'administrator', 
        'president', 
        'logistics-head-manager', 
        'logistics-manager'
      ]
      
      return userRoles.some(role => allowedRoles.includes(role))
    }
  },
  
  mounted() {
    // Инициализация калькулятора
  },
  
  methods: {
    toggleEditMode() {
      this.isEditMode = !this.isEditMode
    },
    
    switchCalculator(calculatorId) {
      this.currentCalculator = calculatorId
    }
  }
}
</script>

<style lang="scss" scoped>
.calculator-page {
  padding: 15px;
  
  .page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    
    h1 {
      color: #0d6348;
      font-size: 24px;
      font-weight: 600;
      margin: 0;
    }
    
    .header-actions {
      .btn {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 12px;
        background: #0d6348;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 12px;
        
        i {
          font-size: 14px;
        }
        
        &:hover {
          background: #0a4d3a;
        }
      }
    }
  }
  
  .calculator-tabs {
    margin-bottom: 20px;
    
    .tabs-container {
      display: flex;
      background: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      
      .tab-button {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 10px 15px;
        background: #fff;
        border: none;
        border-right: 1px solid #e9ecef;
        color: #666;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        font-size: 12px;
        
        &:last-child {
          border-right: none;
        }
        
        i {
          font-size: 16px;
        }
        
        &:hover {
          background: #f8f9fa;
          color: #0d6348;
        }
        
        &.active {
          background: #0d6348;
          color: white;
          
          &:hover {
            background: #0a4d3a;
          }
        }
      }
    }
  }
  
  .page-content {
    .calculator-container {
      background: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      padding: 20px;
      
      .calculator-placeholder {
        text-align: center;
        color: #666;
        
        i {
          font-size: 48px;
          color: #0d6348;
          margin-bottom: 15px;
        }
        
        h3 {
          font-size: 20px;
          margin-bottom: 8px;
          color: #0d6348;
        }
        
        p {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .calculator-page {
    .page-header {
      flex-direction: column;
      gap: 15px;
      text-align: center;
      
      .header-actions {
        width: 100%;
        
        .btn {
          width: 100%;
          justify-content: center;
        }
      }
    }
    
    .calculator-tabs {
      .tabs-container {
        flex-direction: column;
        
        .tab-button {
          border-right: none;
          border-bottom: 1px solid #e9ecef;
          
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
